import { folderRoles } from "@Helpers/constants";
import { t } from "@i18n";

export const moduleWisePermissionsName: any = {
  EMBEDS: {
    1: t("Full Access"),
    2: t("Can Update"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  FORMS: {
    1: t("Full Access"),
    2: t("Can Update"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  CLASH: {
    1: t("Full Access"),
    2: t("Can Update"),
    3: t("Can Comment & Change Status"),
    4: t("Can Download"),
    5: t("Can Publish"),
    6: t("Can View"),
    7: t("No Access"),
  },
  TASKS: {
    1: t("Full Access"),
    2: t("Can Update"),
    3: t("Can Comment & Change Status"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  REVIEWS: {
    1: t("Full Access"),
    2: t("Can Update"),
    6: t("Can View"),
    7: t("No Access"),
  },
  ISSUES: {
    1: t("Full Access"),
    2: t("Can Modify"),
    3: t("Can Comment & Change Status"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  MAILBOX: {
    1: t("Full Access"),
    2: t("Can Update"),
    3: t("Can Reply"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  CONTRACTS: {
    1: t("Full Access"),
    2: t("Can Update"),
    5: t("Can Update Version"),
    6: t("Can View"),
    7: t("No Access"),
  },
  ESTIMATES: {
    1: t("Full Access"),
    2: t("Can Update"),
    5: t("Can Update Version"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  SCHEDULES: {
    1: t("Full Access"),
    2: t("Can Update"),
    5: t("Can Update Version"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  TRANSMITTALS: {
    1: t("Full Access"),
    2: t("Can Consume"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No Access"),
  },
  FILES: {
    1: t("Full Access"),
    2: t("Can Update"),
    4: t("Can Download"),
    5: t("Can Update Version"),
    6: t("Can View"),
    7: t("No Access"),
  },
  FOLDERS: {
    1: t("Full Access"),
    2: t("Can Update"),
    4: t("Can Download"),
    5: t("Can Create or Update Version"),
    6: t("Can View"),
    7: t("No Access"),
  },
  ASSETS: {
    1: t("Full Access"),
    2: t("Can Update"),
    6: t("Can View"),
    7: t("No Access"),
  },
};
export const getRoleIdNameMapper: any = (module: any) => {
  return moduleWisePermissionsName[module];
};

const mouduleWisePermissionsDescription: any = {
  EMBEDS: {
    1: t("Can Update, delete and Change Access"),
    2: t("Can Update"),
    4: t("Can view and download."),
    6: t("Cannot download or update or change access"),
    7: t("Cannot view, download or update or change access"),
  },
  FORMS: {
    1: t("Can Update, delete and Change Access"),
    2: t("Can fill or change form content as defined in the form flow."),
    4: t("Can view and export."),
    6: t("Cannot export or update or change access"),
    7: t("Cannot view, export or update or change access"),
  },
  CLASH: {
    1: t("Can update clash details, delete and Change Access"),
    2: t("Can update clash details"),
    3: t("Can comment, change status and export."),
    4: t("Can view and export."),
    5: t("Can create new Version"),
    6: t("Cannot export or update."),
    7: t("Cannot view, export or update."),
  },
  TASKS: {
    1: t("Can update task details, delete and Change Access"),
    2: t("Can update task details"),
    4: t("Can view and export."),
    6: t("Cannot export or update."),
    7: t("Cannot view, export or update."),
  },
  REVIEWS: {
    1: t("Can update, delete and change access."),
    2: t("Can review, modify, archive"),
    6: t("Cannot update or change access."),
    7: t("Cannot view, update or change access"),
  },
  ISSUES: {
    1: t("Can edit, change access, delete and mark comment as official."),
    2: t("Can comment, edit"),
    3: t("Can comment, change status and export."),
    4: t("Can view and export."),
    6: t("Cannot comment, change status, export or edit. "),
    7: t("Cannot view, comment, change status, export or edit."),
  },
  CONTRACTS: {
    1: t("Can update version, change access and delete."),
    2: t("Can edit"),
    5: t("Can create and publish new version"),
    6: t("Cannot edit, delete or change access."),
    7: t("Cannot view, change access and edit."),
  },
  SCHEDULES: {
    1: t("Can update version, change access and delete."),
    2: t("Can edit"),
    4: t("Can view and export."),
    5: t("Can create and publish new version"),
    6: t("Cannot edit, delete or change access."),
    7: t("Cannot view, download, change access or edit."),
  },
  ESTIMATES: {
    1: t("Can update version, change access and delete."),
    2: t("Can edit"),
    4: t("Can view and export."),
    5: t("Can create and publish new version"),
    6: t("Cannot comment, change access, export or edit. "),
    7: t("Cannot view, comment, change access, export or edit."),
  },
  MAILBOX: {
    1: t("Can update, delete and change access."),
    2: t("Can respond, edit custom fields and modify tags."),
    3: t("Can reply, acknowledge and download"),
    4: t("Can view and export."),
    6: t("Cannot download, reply, update or change access"),
    7: t("Cannot view, download, reply, update or change access"),
  },
  TRANSMITTALS: {
    1: t("Can Consume, delete and change access."),
    2: t("Can consume, download & create shortcuts of files within the transmittal"),
    4: t("Can download & view files within the transmittal"),
    6: t("Cannot download & consume files within the transmittal or change access"),
    7: t("Cannot view, download & consume files within the transmittal or change access"),
  },
  FILES: {
    1: t("Can update version, change access, transmit to other spaces and delete"),
    2: t("Can modify & download"),
    4: t("Can download & view"),
    5: t("Can create and publish new version"),
    6: t("Cannot download, edit or change access"),
    7: t("Cannot view, download, edit or change access"),
  },
  FOLDERS: {
    1: t("Can upload, edit, change access, transmit entities within this folder to other spaces and delete"),
    2: t("Can modify details and download"),
    4: t("Can download & view"),
    5: t("Can upload or create any entities in this folder"),
    6: t("Cannot download, edit or change access"),
    7: t("Cannot view, download, update or change access"),
  },
  ASSETS: {
    1: t("Can update, delete and change access"),
    2: t("Can update and edit custom fields"),
    6: t("Cannot update or change access"),
    7: t("Cannot view, update or change access"),
  },
};
export const getRoleIdDescriptionMapper: any = (module: any) => {
  return mouduleWisePermissionsDescription[module];
};
export const setModulePermissions = (module: any) => {
  const roles: any = [];
  const folderRolesData: any = folderRoles();

  Object.keys(folderRolesData).forEach((key) => {
    roles.push({
      ...folderRolesData[key],
      name: key,
    });
  });

  const filterCondition = (role: any) => {
    const roleId = role.id;

    // RESOURCE_COMMENTER
    if (roleId === folderRolesData.RESOURCE_COMMENTER?.id) {
      return ![
        "FORMS",
        "TRANSMITTALS",
        "FILES",
        "CLASH",
        "FOLDERS",
        "SCHEDULES",
        "ESTIMATES",
        "TASKS",
        "ASSETS",
        "CONTRACTS",
        "EMBEDS",
        "REVIEWS",
      ].includes(module);
    }

    // RESOURCE_CREATOR
    if (roleId === folderRolesData.RESOURCE_CREATOR?.id) {
      return !["FORMS", "TRANSMITTALS", "TASKS", "ASSETS", "REVIEWS", "ISSUES", "EMBEDS", "MAILBOX"].includes(module);
    }

    // RESOURCE_DOWNLOADER
    if (roleId === folderRolesData.RESOURCE_DOWNLOADER?.id) {
      return !["TASKS", "ASSETS", "CONTRACTS", "REVIEWS"].includes(module);
    }

    return true;
  };

  const filteredRoles = roles
    .sort((a: any, b: any) => a.frontendDisplayIndex - b.frontendDisplayIndex)
    .filter((role: any) => filterCondition(role));

  const rolesDescriptionMapper = getRoleIdDescriptionMapper(module);
  const roleIdNameMapper = getRoleIdNameMapper(module);
  const updatedRoles = filteredRoles.map((role: any) => ({
    id: role.id,
    code: role.code,
    description: rolesDescriptionMapper[role.id],
    frontendName: roleIdNameMapper[role.id],
    name: role.name,
  }));

  return updatedRoles;
};
export const defaultAccessFlowSources: {
  PORTAL_SETTINGS: "PORTAL_SETTINGS";
  SPACE_USERS: "SPACE_USERS";
  PROJECT_USERS: "PROJECT_USERS";
} = {
  PORTAL_SETTINGS: "PORTAL_SETTINGS",
  SPACE_USERS: "SPACE_USERS",
  PROJECT_USERS: "PROJECT_USERS",
};
